import React, { useCallback, useState } from 'react'
import { Spinner } from 'gu-ui-kit'
import { Field } from 'redux-form'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'

const TaxNumberField = ({ form, suggestAvailable = false, label, disabled = false }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const handleChange = useCallback(
    (e, newValue, prevValue) => {
      if (!suggestAvailable) return

      if (!newValue !== prevValue) {
        new Promise((resolve) => {
          setLoading(true)
          dispatch({
            type: 'USER/GET_ORGANIZATION_SUGGEST',
            meta: { resolve },
            payload: { tax_number: newValue },
            formName: form,
          })
        }).finally(() => {
          setLoading(false)
        })
      }
    },
    [form, suggestAvailable],
  )

  return (
    <Field
      disabled={disabled}
      fullWidth
      name="details.tax_number"
      component={renderInputField}
      onChange={handleChange}
      label={label ?? t('payment_profiles::new.fields.details.tax_number.label')}
      normalize={(value) => value.replace(/\D/g, '').substr(0, 12) ?? ''}
      t={t}
      InputProps={{
        endAdornment: loading ? <Spinner width={16} color={'Label-GU-Primary'} /> : null,
      }}
    />
  )
}
export default TaxNumberField

TaxNumberField.propTypes = {
  form: PropTypes.string,
  suggestAvailable: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
}
